<template>
  <v-form v-model="valid" ref="RegisterForm" lazy-validation>
    <v-container grid-list-xs>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="Username"
            v-model="username"
            :rules="usernameRules"
            :error-messages="userErrors"
            autofocus
            @input="userErrors = []"
            required />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Password"
            v-model="password"
            :rules="passwordRules"
            type="password"
            required />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Confirm Password"
            v-model="password2"
            :rules="password2Rules"
            type="password"
            :error-messages="passwordNotMatch"
            required />
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="Register">
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="10"
              color="#fff"
              v-if="loading"
            />
            <span v-else>Register</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { LoopingRhombusesSpinner } from 'epic-spinners';

  export default {
    components: {
      LoopingRhombusesSpinner
    },
    computed: {
      ...mapGetters({
       loading: 'user/GET_LOADING'
      }),
      passwordMatch() {
        return this.password === this.password2;
      }
    },
    data: () => ({
      username: '',
      usernameRules: [
        v => !!v || 'Username is required'
      ],
      userErrors: [],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password min. 6 chars'
      ],
      password2: '',
      password2Rules: [
        v => !!v || 'Password is required'
      ],
      passwordNotMatch: [],
      valid: false
    }),
    methods: {
      ...mapActions({
        REQUEST_REGISTER: 'user/REGISTER'
      }),
      Register () {
        this.userErrors = [];
        this.passwordNotMatch = [];
        if (this.$refs.RegisterForm.validate()) {
          if (this.password !== this.password2) {
            this.passwordNotMatch = ['Password dont match'];
            this.valid = false;
          } else {
            this.passwordNotMatch = [];
            this.REQUEST_REGISTER({
              username: this.username,
              password: this.password
            })
              .then(() => this.$emit('REGISTER_SUCCESS'))
              .catch(error => {
                if (error.status === 409) {
                  this.userErrors = [error.data.message];
                }
              });
          }
        }
      }
    }
  }
</script>
